import { Product, Variant, VariantGroup } from "../../types/types";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";

export function promotionalMessagesToShow(
  product: Product,
  selectedVariant: Variant,
  isVariantSelected: boolean,
  showSaveLabels: boolean,
  selectedVariantGroup?: VariantGroup,
) {
  const isPromotionalMessage = (
    message: NonPromotionalMessage | PromotionalMessage,
  ): message is PromotionalMessage => {
    return (message as PromotionalMessage).promotionGroup !== undefined;
  };

  const variantGroupPromotionalMessaging =
    selectedVariantGroup && selectedVariantGroup.messaging
      ? selectedVariantGroup.messaging?.filter<PromotionalMessage>(
          isPromotionalMessage,
        )
      : [];

  const variantPromotionalMessaging = selectedVariant.messaging
    ? selectedVariant.messaging.filter<PromotionalMessage>(isPromotionalMessage)
    : [];

  const productPromotionalMessaging = product.messaging
    ? product.messaging.filter<PromotionalMessage>(isPromotionalMessage)
    : [];

  const hasVariantLevelMessaging =
    isVariantSelected && variantPromotionalMessaging.length;

  const hasVariantGroupLevelMessaging =
    selectedVariantGroup && variantGroupPromotionalMessaging?.length;

  if (hasVariantLevelMessaging || (isVariantSelected && showSaveLabels))
    return variantPromotionalMessaging;
  else if (
    hasVariantGroupLevelMessaging ||
    (selectedVariantGroup && showSaveLabels)
  )
    return variantGroupPromotionalMessaging;
  else return productPromotionalMessaging;
}

interface MonthNumberMap {
  [key: string]: number;
}

export const monthNumberMap: MonthNumberMap = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};
